/**
 * Uçuş aktarma / direkt etiketi — backend connection_label ile uyumlu.
 */
export function formatFlightConnectionLabel(flightOrGroup) {
  if (!flightOrGroup) return '';

  if (flightOrGroup.connection_label) {
    return flightOrGroup.connection_label;
  }

  const stopCount = Number(flightOrGroup.stop_count ?? 0);
  if (stopCount <= 0) {
    return 'Direkt uçuş';
  }
  if (stopCount === 1) {
    return '1 aktarma';
  }
  return `${stopCount} aktarma`;
}

export function isDirectFlight(flightOrGroup) {
  if (!flightOrGroup) return false;
  return Number(flightOrGroup.stop_count ?? 0) <= 0;
}
